import React, { useState, useEffect } from "react";
import classNames from "classnames";

const defaultImg="data:image/svg+xml;base64,PHN2ZwogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICAgIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKPgogIDxyZWN0IG9wYWNpdHk9IjAuMyIgeD0iMyIgeT0iMTAiIHdpZHRoPSIxOCIgaGVpZ2h0PSI0IiByeD0iMiIgZmlsbD0iY3VycmVudENvbG9yIiAvPgogIDxyZWN0IHg9IjciIHk9IjEwIiB3aWR0aD0iMTAiIGhlaWdodD0iNCIgcng9IjIiIGZpbGw9ImN1cnJlbnRDb2xvciIgLz4KPC9zdmc+"
export const GalleryItem = ({ name, size, svg, color, selected, onClick }) => {
  const [imageURI, setImageURI] = useState(defaultImg);
  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    if (svg) {
      const uri = `data:image/svg+xml,${encodeURIComponent(svg)}`;
      setImageURI(uri);
      //  console.log("onloead", imageURI);
      setImageURI(uri);
    }
     // eslint-disable-next-line
  }, [svg]);
  useEffect(() => {
    if (svg) {
      let fill = `<svg fill='${color}'`;
      let svgStr = svg.replace(/<svg/, fill);
      // console.log(svgStr, " new fill", svg);
      const uri = `data:image/svg+xml,${encodeURIComponent(svgStr)}`;

      setImageURI(uri);
      //  console.log(imageURI);
    }
     // eslint-disable-next-line
  }, [svg, color]);

  return (
    <div className="rounded">
      <div
        className={classNames(
          "text-center flex flex-col justify-between dark:bg-gray-800 bg-white mb-6 py-5 px-4",
          { "is-selected": isLoaded && selected },
          { "show-icon": isLoaded },
          { "w-32 h-32": size === "small" },
          { "w-44 h-44": size === "medium" },
          { "w-62 h-62": size === "large" }
        )}
        onClick={onClick}
      >
        <div className="m-auto">
          <div
            className={classNames(
              { "w-12 h-12": size === "small" },
              { "w-20 h-20": size === "medium" },
              { "w-32 h-32": size === "large" }
            )}
            onLoad={() => setIsLoaded(true)}
          >
            <img
              className="w-full h-full"
              src={imageURI}
              alt="icon"
              onLoad={() => setIsLoaded(true)}
            />
          </div>
        </div>
        <span className="icon-name">{name}</span>
      </div>
    </div>
  );
};

// const areEqual = (prevIcon, nextIcon) => {
//   return prevIcon.name === nextIcon.name && prevIcon.svg === nextIcon.svg;
// };

export const MemoGalleryItem = React.memo(GalleryItem);
